export function isActive($auth) {

	"ngInject";

	return () => $auth.isAuthenticated() && ($auth.getUser().extend.is_active === true);

}

export function isNotActive($auth) {

	"ngInject";

	return () => $auth.isAuthenticated() && ($auth.getUser().extend.is_active === false);

}


// WEBPACK FOOTER //
// ./sources/filters/isActive.js